module.exports = __webpack_public_path__ + "media/images/front/icons/window-stack-3307f0a25252f7f72a9ae454872c84c0.svg";